export default [
  [
    {
      id: 'companyName',
      label: 'ผู้จ้าง *',
      span: 10,
      type: 7,
      props: { margin: '0 8px 16px 0', width: '100%', title: { text: 'ผู้จ้าง' } },
    }, {
      id: 'branch',
      label: 'สาขา',
      offset: 1,
      span: 6,
      type: 2,
      props: { margin: '0 8px 16px 0', width: '100%', display: 'block' },
    }, {
      id: 'typeOfCharge',
      label: 'ประเภทผู้จ้าง',
      span: 7,
      type: 2,
      props: { margin: '0 8px 16px 0', width: '100%', display: 'block' },
    }, {
      id: 'dealType',
      label: 'ประเภทสัญญางาน *',
      span: 7,
      type: 3,
      props: { margin: '16px 0' },
      children: [
        {
          value: 'PERWEIGHT',
          text: 'ต่อน้ำหนัก',
        }, {
          value: 'PERTRIP',
          text: 'ต่อเที่ยว',
        },
      ],
    }, {
      id: 'predealPrice',
      span: 6,
      type: 0,
      props: { margin: '16px 40px 0 0', width: '100%', title: { text: 'ราคาน้ำมันที่ใช้คิดเงิน' } },
    },
  ], [
    {
      id: 'startDestination',
      label: 'ต้นทาง *',
      span: 10,
      type: 9,
      props: { margin: '0 40px 0 0', width: '100%' },
    }, {
      id: 'startDestinationText',
      span: 2,
      type: 10,
      props: { margin: '40px 0 0', width: '100%', display: 'block' },
    }, {
      id: 'endDestination',
      label: 'ปลายทาง *',
      span: 10,
      type: 9,
      props: { margin: '0 40px 0 0', width: '100%' },
    }, {
      id: 'endDestinationText',
      span: 2,
      type: 10,
      props: { margin: '40px 0 0', width: '100%', display: 'block' },
    }, {
      id: 'distance',
      label: 'ระยะทาง (กิโลเมตร) *',
      span: 6,
      type: 0,
      props: { width: '100%', title: { text: 'ระยะทาง (กิโลเมตร) *' }, margin: '16px 0' },
    }, {
      id: 'feeRate',
      label: 'อัตราค่าขนส่งที่คิดลูกค้า *',
      span: 6,
      type: 0,
      props: { width: '100%', title: { text: 'อัตราค่าขนส่งที่คิดลูกค้า *' }, margin: '16px 0' },
    }, {
      id: 'truckOwnerFeeRate',
      label: 'อัตราค่าขนส่งที่คิดรถร่วม *',
      span: 6,
      type: 0,
      props: { width: '100%', title: { text: 'อัตราค่าขนส่งที่คิดรถร่วม *' }, margin: '16px 0' },
    }, {
      id: 'availableOrder',
      span: 8,
      type: 12,
      label: 'จำนวนใบสั่งบรรทุกที่สามารถสร้างได้',
    }, {
      id: 'shippings',
      span: 8,
      type: 12,
      label: 'จำนวนใบสั่งบรรทุกที่สร้างแล้ว',
    }, {
      id: 'remainingOrder',
      span: 8,
      type: 12,
      label: 'จำนวนใบสั่งบรรทุกที่เหลือ',
    },
  ], [
    {
      id: 'cargo',
      label: 'ประเภทสินค้า',
      span: 4,
      type: 0,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'ประเภทสินค้า' } },
    }, {
      id: 'contractWeight',
      label: 'น้ำหนัก/เที่ยวทั้งหมด',
      span: 4,
      type: 0,
      props: { width: '100%', title: { text: 'น้ำหนัก/เที่ยวทั้งหมด' } },
    }, {
      id: 'deliveredWeight',
      label: 'น้ำหนัก/เที่ยวที่ขนส่งแล้ว',
      span: 4,
      type: 8,
      props: { title: { text: 'น้ำหนัก/เที่ยวที่ขนส่งแล้ว' } },
      onlyView: false,
    }, {
      id: 'average',
      label: 'น้ำหนักเฉลี่ยของรถ',
      span: 4,
      type: 13,
      props: { width: '100%', title: { text: 'น้ำหนักเฉลี่ยของรถ' } },
    }, {
      id: 'unit',
      type: 11,
      span: 4,
    },
    // {
    //   id: 'unit', // dropdown
    //   label: 'หน่วย',
    //   span: 4,
    //   type: 5,
    //   disabled: true,
    //   props: { margin: '0 8px 16px 0', width: '100%', title: { text: 'น้ำหนักทั้งหมด' } },
    //   children: [
    //     {
    //       value: 'TON',
    //       text: 'ตัน',
    //     }, {
    //       value: 'TONN',
    //       text: 'เที่ยว', // Work around
    //     }, {
    //       value: 'NORMALKILOGRAM',
    //       text: 'กิโลกรัม',
    //     }, {
    //       value: 'KILOGRAM50',
    //       text: 'กระสอบ 50 กิโลกรัม',
    //     }, {
    //       value: 'KILOGRAM60',
    //       text: 'กระสอบ 60 กิโลกรัม',
    //     }, {
    //       value: 'KILOGRAM100',
    //       text: 'กระสอบ 100 กิโลกรัม',
    //     },
    //   ],
    // },
  ], [
    {
      id: 'remark', // textArea
      label: 'หมายเหตุ',
      span: 12,
      type: 6,
      props: { margin: '0 40px 0 0', width: '100%', title: { text: 'หมายเหตุ' } },
    }, {
      id: 'Jobfiles', // Upload
      label: 'Attachments',
      span: 24,
      type: 4,
      props: { margin: '0 8px 0 0' },
    },
  ],
]
